<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout"
                               active
                               v-bind:href=productSheet
                               target='_blank'>
                               Product Sheet
    </b-nav-item>
    </b-nav>
    </div>
    <div>
    <div class="main-div">
    <div class="login-div">
    <div class="profile-div col-11">
      <h5 class="mt-3 mb-3"> Facit Milestone Real Time Occupancy </h5><br>

      <div class="mt-3 mb-5 text-center">
        <b-img class="imgOccupancy marginImage text-center mt-3" src="https://portal.facitdatasystems.com/api/Containers/facitdownloads/download/Applications%2FMilestone%2FReal%20Time%20Occupancy-1.png" fluid alt="Fluid image"></b-img>
        <b-img class="imgOccupancy text-center mt-3" src="https://portal.facitdatasystems.com/api/Containers/facitdownloads/download/Applications%2FMilestone%2FReal%20Time%20Occupancy-2.png" fluid alt="Fluid image"></b-img>
      </div>

      <h5 class="mt-3 mb-4"> How to Guide </h5>

      <b-card-group deck class="mt-3 mb-4">
       <b-card
         header="SETP 1: Download Software"
         header-tag="header"
       >
       <b-table  striped hover
                 :fields="fields"
                 :items="applications">
         <template slot="link" slot-scope="data">
           <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
         </template>
       </b-table>
       <b-card-text></b-card-text>
       </b-card>
       </b-card-group>
       <b-card-group deck class="mt-3 mb-4">
        <b-card
          header="SETP 2: Documentation"
          header-tag="header"
        >
        <b-table  striped hover
                  :fields="fields"
                  :items="documentation">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table>
        <b-card-text></b-card-text>
        </b-card>
        </b-card-group>
      <b-card-group deck class="mt-3 mb-4">
       <b-card
         header="STEP 3: Facit Milestone Smart Count Plugin - Installation"
         header-tag="header"
         body-class="text-center"
       >
       <div class="wdiv">
         <b-embed
           type="iframe"
           aspect="16by9"
           src="https://www.youtube.com/embed/uX1ve4B2yqI"
         ></b-embed>
       </div>
     <b-card-text></b-card-text>
   </b-card>
 </b-card-group>
 <b-card-group deck class="mt-3 mb-4">
<b-card
header="STEP 4: Facit Milestone Smart Count Web Server - Installation"
header-tag="header"
body-class="text-center">
<div class="wdiv">
  <b-embed
    type="iframe"
    aspect="16by9"
    src="https://www.youtube.com/embed/gQtexHD-vw0"
  ></b-embed>
</div>
<b-card-text></b-card-text>
</b-card>
</b-card-group>
 <b-card-group deck class="mt-3 mb-4">
  <b-card
    header="STEP 5: Facit Milestone Smart Count Notification - Installation"
    header-tag="header"
    body-class="text-center"
  >
  <div class="wdiv">
    <b-embed
      type="iframe"
      aspect="16by9"
      src="https://www.youtube.com/embed/En6u9XODdOY"
    ></b-embed>
  </div>
<b-card-text></b-card-text>
</b-card>
</b-card-group>
<b-card-group deck class="mt-3 mb-4">
<b-card
 header="STEP 6: Facit Milestone Smart Count Web Server - Configuration"
 header-tag="header"
 body-class="text-center">
<div class="wdiv">
 <b-embed
   type="iframe"
   aspect="16by9"
   src="https://www.youtube.com/embed/xefiojy9HMI"
 ></b-embed>
</div>
<b-card-text></b-card-text>
</b-card>
</b-card-group>
<b-card-group deck class="mt-3 mb-4">
 <b-card
   header="STEP 7: Facit Milestone Smart Count Plugin - Activate Licence & Add Cameras"
   header-tag="header"
   body-class="text-center"
 >
 <div class="wdiv">
   <b-embed
     type="iframe"
     aspect="16by9"
     src="https://www.youtube.com/embed/xgAAvsxsgHI"
   ></b-embed>
 </div>
<b-card-text></b-card-text>
</b-card>
</b-card-group> <br><br><br>
</div>
</div>
</div>
</div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import _ from 'lodash'

export default {
  name: 'FacitMilestoneSmartCount',
  components: { FacitHeader },
  data() {
    return {
      applications: [],
      productSheet: '',
      documentation: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'size',
          label: 'Size',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.getDownloads();
},
  methods: {
    async getDownloads() {
      const downloads = await API.get('Downloads');
      const downloadsList = _.groupBy(downloads, 'name')
      this.productSheet = downloadsList['Smart Count Real Time Occupancy - Milestone'][0].link
      downloads.forEach(records => {
        if (records.type === 15) {
          this.applications.push(records)
        } else if (records.type === 17) {
          this.documentation.push(records)
        }
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
  width: 80%;
}
.wdiv {
  width: 600px;
  margin: auto;
}
.imgOccupancy {
  width: 500px;
}
.marginImage {
  margin: auto;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.logout {
  margin-top: 28px;
}
.active {
  color: #ff8f00 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FacitMilestoneSmartCount.vue